import {
    Component,
    Input,
    
    OnDestroy,
    OnInit,
    EventEmitter,
    Output,
    OnChanges,
    SimpleChanges,
    ChangeDetectorRef,
} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { CruiseFiltersService } from '@app/services/cruis/cruisefilters.service';
import { CruiseService } from '@app/services/cruise.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
    cruisesearchTypes,
    cruisegsPrice,
    cruisecabinCat,
    cruiselanguage,
    cruisemaxPass,
    cruisereiseDauer,
} from '../tools/CruiseStatic';
import { Schiffe } from '@app/models/kreuzfahrts/Schiffe';
interface Item {
    id: string;
    name: string;
    selected?: boolean;
    description?: string;
    land?: string;
}
@Component({
    selector: 'app-cruiseextrafilters',
    templateUrl: './cruiseextrafilters.component.html',
    styleUrls: ['./cruiseextrafilters.component.scss'],
    standalone: false,
})
export class CruiseextrafiltersComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Output() closeModal: EventEmitter<boolean> = new EventEmitter();

    cruisesearchtypedata: string = '';
    specialcode: string = '';

    cruisedurationdata: string = '';

    cruiseboardlanguagedata: string = '';

    cruisemaxanzpassdata: string = '';

    cruisemaxpricedata: string = '';

    cruisecabincatdata: string = '';

    desktopTemplate: string = 'xl';
    showSmallMode: boolean = false;
    loading: boolean = false;
    shipNames: any[] = [];

    currentpartner: Partner;
    protected unsubscribe$ = new Subject();
    searchTypes: Item[];
    reiseDauer: Item[];
    maxPass: Item[];
    cabinCat: Item[];
    gsPrice: Item[];
    language: Item[];
    allShips: any[] = [];
    ports: any[] = [];
    filteredPorts: any[] = [];
    selectedPorts: any[] = [];
    portSearchTerm: string = '';

    constructor(
        protected cruiseFiltersService: CruiseFiltersService,
        protected cruiseService: CruiseService,
        protected mediaObserver: BreakpointObserver,
        protected guardService: AuthGuardService,
        protected cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.searchTypes = JSON.parse(JSON.stringify(cruisesearchTypes));
        this.reiseDauer = JSON.parse(JSON.stringify(cruisereiseDauer));
        this.maxPass = JSON.parse(JSON.stringify(cruisemaxPass));
        this.cabinCat = JSON.parse(JSON.stringify(cruisecabinCat));
        this.gsPrice = JSON.parse(JSON.stringify(cruisegsPrice));
        this.language = JSON.parse(JSON.stringify(cruiselanguage));
        this.initMedia();
        this.initPartner();
        this.cruiseFiltersService.cruisesuchetype$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((type) => {
                if (type && this.cruisesearchtypedata !== type) {
                    this.cruisesearchtypedata = type;
                    this.updateSearchTypeSelection(type);
                }
            });
        this.cruiseFiltersService.companyChange$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((selectedCompanies) => {
                if (selectedCompanies) {
                    this.filterShipsByCompany(selectedCompanies);
                }
            });
    }
    updateSearchTypeSelection(type: string): void {
        this.searchTypes = this.searchTypes.map((item) => ({
            ...item,
            selected: item.id === type,
        }));
        this.cdr.detectChanges();
    }

    fetchShipNames(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.cruiseService
                .request({ ref: this.currentpartner?.xt?.ref }, 'cruisecompanyships')
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                    next: (res: any[]) => {
                        this.allShips = res.map((s) => ({
                            id: s.id,
                            name: s.name,
                            vc: s.vc, // company ID
                            selected: false,
                        }));

                        this.shipNames = [...this.allShips];
                        this.cdr.detectChanges();
                        resolve(); // ✅ important
                    },
                    error: (err) => reject(err),
                });
        });
    }

    filterShipsByCompany(selectedCompanies: any[]) {
        if (!selectedCompanies?.length) {
            this.shipNames = [...this.allShips];
            this.cdr.detectChanges();
            return;
        }
        const selectedCompanyIds = selectedCompanies.map((c) => Number(c.id));
        this.shipNames = this.allShips.filter((s) =>
            selectedCompanyIds.includes(Number(s.vc))
        );

        this.cdr.detectChanges();
    }

    async cruiseshipnameresult(ev) {
        this.cruiseFiltersService.schiffes([ev], this.mode !== 'home');
    }

    async getPorts() {
        this.cruiseService
            .request({ ref: this.currentpartner?.xt?.ref }, 'cruiseregionsdsi')
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((res: any[]) => {
                this.ports = this.mapAndSortPorts(res);
                this.filterPorts();

                this.cdr.detectChanges();
            });
    }

    private mapAndSortPorts(ports: any[]): any[] {
        return ports
            .map((port) => ({
                id: port.code,
                name: (port.name || '').trim(),
                selected: false,
            }))
            .filter((port) => port.name)
            .sort((a, b) =>
                a.name.localeCompare(b.name, 'de', {
                    sensitivity: 'base',
                    numeric: true,
                })
            );
    }

    filterPorts(): void {
        const searchTerm = this.portSearchTerm.trim().toLocaleLowerCase('de');
        this.filteredPorts = !searchTerm
            ? [...this.ports]
            : this.ports.filter((port) =>
                port.name.toLocaleLowerCase('de').includes(searchTerm)
            );
    }

    onPortSelectOpened(isOpen: boolean): void {
        if (!isOpen) return;
        this.portSearchTerm = '';
        this.filterPorts();
    }

    clearPortSelection() {
        this.selectedPorts = [];
        this.ports.forEach((port) => (port.selected = false));
        this.cruiseportresult([]);
        this.cdr.detectChanges();
    }

    async cruiseportresult(ports: any[]) {
        this.selectedPorts = ports || [];
        this.ports.forEach((port) => {
            port.selected = this.selectedPorts.some((selectedPort) => selectedPort.id === port.id);
        });
        this.cruiseFiltersService.cruisezwischenhaefen(this.selectedPorts, this.mode !== 'home');
    }

    async initPartner() {
        this.guardService.getPartner$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((partner) => {
                if (partner?.partnerid?.length > 0) {
                    this.currentpartner = partner;
                    this.initFilters();
                    this.getPorts();
                }
            });
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
        this.cdr.detectChanges();
    }

    async initFilters() {
        this.cruiseFiltersService.getfilters$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(async (params) => {
                if (!params) return;
                this.cruisesearchtypedata = params.cruisesuchetype;
                this.cruisedurationdata = params.cruiseduration;
                this.cruiseboardlanguagedata = params.cruiseboardlanguage;
                this.specialcode = params.promo;
                this.cruisemaxpricedata = params.cruisemaxprice;
                this.cruisecabincatdata = params.cruisecabincat;
                this.cruisemaxanzpassdata = params.cruisemaxanzpass;
                this.checkSelections();

                if (!this.allShips.length) {
                    await this.fetchShipNames();
                }

                this.filterShipsByCompany(params.cruisecompanys);
                if (!this.ports.length) {
                    await this.loadPortsAndSelectZwi(params.zwi);
                } else {
                    this.selectZwiPort(params.zwi);
                }
            });
    }
    // Loads ports, then selects the one matching ZWI
    async loadPortsAndSelectZwi(zwiCode: string) {
        return new Promise<void>((resolve) => {
            this.cruiseService
                .request({ ref: this.currentpartner?.xt?.ref }, 'cruiseregionsdsi')
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((res: any[]) => {
                    this.ports = this.mapAndSortPorts(res);
                    this.filterPorts();

                    this.selectZwiPort(zwiCode);
                    this.cdr.detectChanges();
                    resolve();
                });
        });
    }

    // Restores the selected intermediate ports from the URL/filter state.
    selectZwiPort(zwiCode: string) {
        const portCodes = (zwiCode || '').split(',').filter(Boolean);
        this.selectedPorts = this.ports.filter((port) => portCodes.includes(port.id));
        this.ports.forEach((port) => {
            port.selected = portCodes.includes(port.id);
        });
        this.cdr.detectChanges();
    }

    async checkSelections() {
        this.searchTypes = JSON.parse(
            JSON.stringify(
                this.checkData(this.searchTypes, this.cruisesearchtypedata)
            )
        );
        this.reiseDauer = JSON.parse(
            JSON.stringify(this.checkData(this.reiseDauer, this.cruisedurationdata))
        );
        this.maxPass = JSON.parse(
            JSON.stringify(this.checkData(this.maxPass, this.cruisemaxanzpassdata))
        );
        this.cabinCat = JSON.parse(
            JSON.stringify(this.checkData(this.cabinCat, this.cruisecabincatdata))
        );
        this.gsPrice = JSON.parse(
            JSON.stringify(this.checkData(this.gsPrice, this.cruisemaxpricedata))
        );
        this.language = JSON.parse(
            JSON.stringify(
                this.checkData(this.language, this.cruiseboardlanguagedata)
            )
        );
    }

    checkData(array, selected): any[] {
        for (let i = 0; i < array.length; i++) {
            array[i].selected = array[i].id === selected;
        }
        return array;
    }

    checkListData(array, selected): any[] {
        if (array?.length > 0 && selected?.length > 0) {
            for (let i = 0; i < array?.length; i++) {
                for (let j = 0; j < selected?.length; j++) {
                    if (array[i].id === selected[j].code) {
                        array[i].selected = true;
                    }
                }
            }
        } else if (selected?.length > 0) {
            array = [];
            for (let j = 0; j < selected?.length; j++) {
                array.push({
                    id: selected[j].code,
                    name: selected[j].name,
                    selected: true,
                });
            }
        }
        return array;
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    cruisesearchtyperesult(ev): void {
        this.cruisesearchtypedata = ev?.id;
        this.cruiseFiltersService.cruisesuchetype(
            this.cruisesearchtypedata,
            this.mode !== 'home'
        );
    }

    async cruisedurationresult(ev) {
        this.cruisedurationdata = ev?.id;
        this.cruiseFiltersService.cruiseduration(
            this.cruisedurationdata,
            this.mode !== 'home'
        );
    }

    async setSpecial(ev) {
        this.cruiseFiltersService.promo(ev);
        // this.cruiseFiltersService.pmc(ev);
    }

    async cruiseboardlanguageresult(ev) {
        this.cruiseboardlanguagedata = ev?.id;
        this.cruiseFiltersService.cruiseboardlanguage(
            this.cruiseboardlanguagedata,
            this.mode !== 'home'
        );
    }

    async cruisemaxanzpassresult(ev) {
        this.cruisemaxanzpassdata = ev?.id;
        this.cruiseFiltersService.cruisemaxanzpass(
            this.cruisemaxanzpassdata,
            this.mode !== 'home'
        );
    }

    async cruisemaxpriceresult(ev) {
        this.cruisemaxpricedata = ev?.id;
        this.cruiseFiltersService.cruisemaxprice(
            this.cruisemaxpricedata,
            this.mode !== 'home'
        );
    }

    async cruisecabincatresult(ev) {
        this.cruisecabincatdata = ev?.id;
        this.cruiseFiltersService.cruisecabincat(
            this.cruisecabincatdata,
            this.mode !== 'home'
        );
    }

    async makeSearch() {
        this.cruiseFiltersService.changeUrl();
    }

    closeextras(): void {
        this.closeModal.emit(true);
    }

    async resetAll() {
        this.cruiseFiltersService.resetAllExtrasHome();
    }

    async resetAllExtra() {
        this.cruiseFiltersService.resetAllExtras();
    }
}
